import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import {
  fetchClusterByIdFailure,
  fetchClusterByIdSuccess,
  fetchClusterDigDeeperItemsFailure,
  fetchClusterDigDeeperItemsSuccess,
} from "domains/clusters/actions";
import type { ClusterDigDeeperDefaultAction, ClusterItemDefaultAction } from "domains/clusters/actionTypes";
import type { Cluster } from "domains/clusters/types";
import type { KnowledgeResponse } from "entities/knowledge/types";

export const DIG_DEEPER_LIMIT = 20;

export function* clusterItemSaga({ meta }: ClusterItemDefaultAction) {
  try {
    const payload: Cluster = yield apiFetch(`monitor/cluster/${meta.id}`);
    yield put(fetchClusterByIdSuccess(meta, payload));
  } catch {
    yield put(fetchClusterByIdFailure(meta));
  }
}

export function* clusterKnowledgeSaga({ meta }: ClusterDigDeeperDefaultAction) {
  try {
    const { id, offset = 0 } = meta;
    const payload: KnowledgeResponse[] = yield apiFetch(`monitor/cluster/${id}/knowledge`, {
      queryParams: {
        limit: DIG_DEEPER_LIMIT,
        offset: offset * DIG_DEEPER_LIMIT,
      },
    });
    yield put(fetchClusterDigDeeperItemsSuccess(meta, payload));
  } catch {
    yield put(fetchClusterDigDeeperItemsFailure(meta));
  }
}
